"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CountryInfo = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const CountryInfo = ({
  label,
  value
}) => {
  if (!label || !value) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
    children: [label, ": ", value]
  });
};
exports.CountryInfo = CountryInfo;
